/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TaskAssignee } from './TaskAssignee';
import type { TaskContext } from './TaskContext';
import type { TaskStatus } from './TaskStatus';
/**
 * Response type for task creation
 */
export type TaskCreateResponse = {
    /**
     * Unique task identifier.
     */
    id: string;
    /**
     * Tenant that owns this task.
     */
    tenantId: string;
    /**
     * Context linking the task to other entities.
     */
    context: TaskContext;
    /**
     * Entity that created the task.
     */
    createdBy: TaskAssignee;
    /**
     * Entity responsible for completing the task.
     */
    assignedTo: TaskAssignee;
    /**
     * Description of what needs to be accomplished.
     */
    objective: string;
    /**
     * Due date, when scheduled.
     */
    dueDate?: string | null;
    /**
     * Current lifecycle status.
     */
    status: TaskStatus;
    /**
     * When the due task was published.
     */
    publishedAt?: string | null;
    /**
     * When the task was completed.
     */
    completedAt?: string | null;
    /**
     * When the task was cancelled.
     */
    cancelledAt?: string | null;
    /**
     * Reason for cancellation.
     */
    cancellationReason?: string | null;
    /**
     * Creation timestamp.
     */
    createdAt: string;
    /**
     * Last-update timestamp.
     */
    updatedAt: string;
    /**
     * Whether this request created a task or reused an idempotent task.
     */
    creationDisposition?: TaskCreateResponse.creationDisposition;
};
export namespace TaskCreateResponse {
    /**
     * Whether this request created a task or reused an idempotent task.
     */
    export enum creationDisposition {
        CREATED = 'created',
        REUSED = 'reused',
    }
}

